import {
    RouteLocationInterface,
    RouteHttpVerb,
    RouteResponseInterface,
    RouteRequestInterface,
    RouteParamsInterface
} from "@wpnotes/utils";

export const locationRestTodoDelete: RouteLocationInterface = {
    path: "/todo/:id",
    method: RouteHttpVerb.DELETE
};

export type RequestRouteTodoDelete = RouteRequestInterface;

export type ParamsRouteTodoDelete = RouteParamsInterface;

export interface ResponseRouteTodoDelete extends RouteResponseInterface {
    message: string;
    errors?: string[];
}
